import React from 'react';
import { Box } from '@mui/material';
import { managerLayoutStyles } from './styles.ts';
import type { ILayoutShellProps } from './types.ts';

const LayoutShell: React.FC<ILayoutShellProps> = ({ children }) => {
  return (
    <Box sx={managerLayoutStyles.shell}>
      <Box sx={managerLayoutStyles.pageArea}>{children}</Box>
    </Box>
  );
};

export default LayoutShell;
